import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

interface SetInfo {
  name: string;
  display_name: string;
  img: string | null;
}

interface PackInfo {
  name: string;
  img: string | null;
}

export function useFilterOptions() {
  const [options, setOptions] = useState<{
    packs: PackInfo[];
    rarities: string[];
    sets: SetInfo[];
    types: string[];
    energies: string[];
  }>({
    packs: [],
    rarities: [],
    sets: [],
    types: [],
    energies: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchOptions = async () => {
      try {
        // Get distinct values using PostgreSQL DISTINCT
        const { data: distinctValues, error: distinctError } = await supabase
          .rpc('get_distinct_card_values');

        if (distinctError) throw distinctError;

        const { packs: packNames, rarities, sets: setNames, types, energies } = distinctValues;

        // Récupérer les informations complètes des sets
        const { data: setsData, error: setsError } = await supabase
          .from('sets')
          .select('name, display_name, img')
          .in('name', setNames || []);

        if (setsError) throw setsError;

        // Récupérer les informations complètes des packs
        const { data: packsData, error: packsError } = await supabase
          .from('packs')
          .select('name, img')
          .in('name', packNames || []);

        if (packsError) throw packsError;

        // Trier les sets par nom d'affichage
        const sortedSets = (setsData || []).sort((a, b) => 
          (a.display_name || a.name).localeCompare(b.display_name || b.name)
        );

        // Trier les packs par nom
        const sortedPacks = (packsData || []).sort((a, b) => 
          a.name.localeCompare(b.name)
        );

        setOptions({
          packs: sortedPacks,
          rarities: rarities.sort() || [],
          sets: sortedSets,
          types: types?.sort() || [],
          energies: energies?.sort() || []
        });
      } catch (err) {
        console.error('Error fetching filter options:', err);
        setError(err instanceof Error ? err.message : 'An error occurred');
      } finally {
        setLoading(false);
      }
    };

    fetchOptions();
  }, []);

  return { ...options, loading, error };
}